import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import api from '@/lib/api';
import { useAuth } from '@/context/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { applyToken } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || '';
    const m = hash.match(/session_id=([^&]+)/);
    (async () => {
      if (!m) { navigate('/login'); return; }
      try {
        const { data } = await api.post('/auth/google-session', { session_id: decodeURIComponent(m[1]) });
        applyToken(data.token, data.user);
        window.history.replaceState(null, '', window.location.pathname);
        toast.success('Connexion Google réussie');
        navigate('/');
      } catch (e) {
        toast.error(e?.response?.data?.detail || 'Connexion Google impossible');
        window.history.replaceState(null, '', '/login');
        navigate('/login');
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="app-bg flex min-h-screen items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-muted border-t-[color:var(--tenant-accent-500)]" />
        <span className="font-display text-sm text-muted-foreground">Connexion en cours…</span>
      </div>
    </div>
  );
}
